export enum TransactionType {
    Received = 'Received',
    Paid = 'Paid',
}

export interface CashierShiftProps {
    cashierId?: string;
    shiftId?: string;
}
